export default {
  name: "CourseMappingMitra",
  computed: {
    isLoading() {
      return this.$store.getters["courseMappingMitra/getLoading"];
    },
    positionOptions() {
      return this.$store.getters["courseMappingMitraFilters/getPositions"] || [];
    },
    // Training data
    trainings() {
      return this.$store.getters["courseMappingMitraFilters/getTrainings"] || [];
    },
    trainingsPagination() {
      return this.$store.getters["courseMappingMitraFilters/getTrainingsPagination"] || { total: 0, page: 1, limit: 10, totalPage: 0 };
    },
    selectedTrainings() {
      return this.$store.getters["courseMappingMitraFilters/getSelectedTrainings"] || [];
    },
    isTrainingLoading() {
      return this.$store.getters["courseMappingMitraFilters/getLoading"]('trainings');
    },
    isSaving() {
      return this.$store.getters["courseMappingMitraFilters/getLoading"]('saving');
    },
    allTrainingsSelected() {
      if (this.trainings.length === 0) return false;
      return this.trainings.every(training => this.isTrainingSelected(training.id));
    }
  },
  data() {
    return {
      listTabMenu: {
        privilages: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      },
      body: {
        page: 1,
        limit: 10,
        search: "",
        order: ""
      },
      filters: {
        position_id: "",
        search: ""
      },
      bodyAdd: {
        position_id: "",
        competency_id: "",
        role_id: "",
        required: false
      },
      viewDetailData: {},
      isAdd: true,
      modalTitle: "Add Course Mapping Mitra",
      searchTimeout: null,
      showTrainingTable: false,
      selectedFile: null,
      isUploading: false,
      isDownloading: false,
      trainingColumns: [
        {
          label: "ID",
          field: "training_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "20%"
        },
        {
          label: "COURSE",
          field: "title",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "50%"
        },
         {
          label: "ROLE ID",
          field: "role_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "20%"
        },
        {
          label: "REQUIRED",
          field: "required",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "10%"
        }
      ]
    };
  },
  mounted() {
    // Load positions for filter
    this.loadPositions();
    
    // Hide training table initially
    this.showTrainingTable = false;
    
    // Set menu permissions
    this.setMenuPermissions();
  },
  methods: {
    // Set menu permissions
    setMenuPermissions() {
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || '[]');
      const currentPath = window.location.pathname;
      const menu = listMenu.find((menu) =>
        menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
      );
      this.listTabMenu = menu ? menu.children.find((item) => item.link === currentPath) || menu : {};
    },

    // Helper methods
    getPositionName(positionId) {
      const position = this.positionOptions.find(p => p.id === positionId || p.position_id === positionId);
      return position ? (position.position_title || position.name) : positionId;
    },

    getRoleDescription(roleId) {
      const roles = {
        'PO': 'Pengawas Operasional',
        'PT': 'Pengawas Teknis',
        'TT': 'Tenaga Teknis'
      };
      return roles[roleId] || roleId;
    },

    // Filter API methods
    async loadPositions() {
      await this.$store.dispatch("courseMappingMitraFilters/fetchPositions");
    },

    async onPositionChange() {
      if (this.filters.position_id) {
        // Load trainings and show table
        await this.loadTrainings();
        this.showTrainingTable = true;
        
        // Load training mapping for this position
        this.loadTrainingMapping();
      } else {
        // Clear training selections
        this.$store.dispatch("courseMappingMitraFilters/clearSelectedTrainings");
        this.showTrainingTable = false;
      }
    },

    // Training methods
    async loadTrainings() {
      const params = {
        page: this.body.page,
        limit: this.body.limit,
        search: this.filters.search || ''
      };
      await this.$store.dispatch("courseMappingMitraFilters/fetchTrainings", params);
    },

    async loadTrainingMapping() {
      if (this.filters.position_id) {
        await this.$store.dispatch("courseMappingMitraFilters/fetchTrainingMapping", this.filters.position_id);
      }
    },

    isTrainingSelected(trainingId) {
      return this.$store.getters["courseMappingMitraFilters/isTrainingSelected"](trainingId);
    },

    toggleTrainingSelection(trainingId) {
      this.$store.dispatch("courseMappingMitraFilters/toggleTrainingSelection", trainingId);
    },

    toggleAllTrainings() {
      if (this.allTrainingsSelected) {
        // Unselect all
        this.$store.dispatch("courseMappingMitraFilters/clearSelectedTrainings");
      } else {
        // Select all
        this.trainings.forEach(training => {
          if (!this.isTrainingSelected(training.id)) {
            this.$store.dispatch("courseMappingMitraFilters/toggleTrainingSelection", training.id);
          }
        });
      }
    },

    // Rename clearFilters to match template
    clearFilters() {
      this.clearFilter();
    },

    // Search with debounce
    onSearch() {
      // Clear existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      // Debounce search
      this.searchTimeout = setTimeout(() => {
        if (this.showTrainingTable) {
          this.body.page = 1; // Reset to first page on search
          this.loadTrainings();
        }
      }, 500);
    },

    // Filter
    clearFilter() {
      this.filters = {
        position_id: "",
        search: ""
      };
      
      // Clear training selections
      this.$store.dispatch("courseMappingMitraFilters/clearSelectedTrainings");
      
      // Hide training table
      this.showTrainingTable = false;
    },

    // Actions
    addData() {
      this.isAdd = true;
      this.modalTitle = "Add Course Mapping Mitra";
      this.resetAddForm();
      this.$bvModal.show("modal-course-mapping-mitra");
    },

    viewData(data) {
      this.isAdd = null; // View mode
      this.modalTitle = "View Course Mapping Mitra";
      this.viewDetailData = data;
      this.$bvModal.show("modal-course-mapping-mitra");
    },

    resetAddForm() {
      this.bodyAdd = {
        position_id: "",
        competency_id: "",
        role_id: "",
        required: false
      };
      this.$validator.reset();
    },

    // Save methods
    saveAdd() {
      // Validate that position is selected
      if (!this.filters.position_id) {
        this.$swal("Error", "Pilih jabatan terlebih dahulu", "error");
        return;
      }

      // Get selected trainings
      const selectedTrainings = this.$store.getters["courseMappingMitraFilters/getSelectedTrainings"];
      
      if (selectedTrainings.length === 0) {
        this.$swal("Error", "Pilih minimal satu pelatihan", "error");
        return;
      }

      // Prepare body with training_ids as array of strings and position_level_id as number
      const body = {
        training_ids: selectedTrainings.map(id => String(id)),
        position_level_id: Number(this.filters.position_id)
      };

      // Dispatch to store
      this.$store.dispatch("courseMappingMitraFilters/saveContractorTrainingMapping", body)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Mapping pelatihan berhasil disimpan",
            icon: "success",
            confirmButtonText: "OK"
          });
          
          // Refresh the training mapping
          this.loadTrainingMapping();
        })
        .catch((error) => {
          console.error("Error saving contractor training mapping:", error);
          let errorMessage = "Error while saving training mapping";
          
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.error) {
              errorMessage = errorData.error;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        });
    },

    // API calls
    getPositionCompetencyMappings() {
      const params = { ...this.body };
      if (this.filters.position_id) params.position_id = this.filters.position_id;
      if (this.filters.course) params.course = this.filters.course;
      if (this.filters.search) params.search = this.filters.search;
      
      this.$store.dispatch("courseMappingMitra/getPositionCompetencyMappings", params);
    },

    getPositions() {
      this.$store.dispatch("position/getPositions", {
        limit: 100
      });
    },

    getCompetencies() {
      this.$store.dispatch("competency/getCompetencies", {
        limit: 100
      });
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.loadTrainings();
    },

    onPerPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = 1;
      this.loadTrainings();
    },

    // Upload methods
    showUploadModal() {
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.$bvModal.show('modal-upload-mitra');
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file size (5MB max)
        if (file.size > 5 * 1024 * 1024) {
          this.$swal({
            title: 'Error',
            text: 'Ukuran file harus kurang dari 5MB',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          event.target.value = '';
          return;
        }
        
        // Validate file type
        if (!file.name.toLowerCase().endsWith('.xlsx')) {
          this.$swal({
            title: 'Error',
            text: 'Hanya file .xlsx yang diizinkan',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          event.target.value = '';
          return;
        }
        
        this.selectedFile = file;
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },

    async downloadTemplate() {
      if (this.isDownloading) return;

      this.isDownloading = true;

      try {
        const response = await this.$store.dispatch('courseMappingMitraFilters/downloadTemplate');
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', 'Contractor Training Mapping Template.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$swal({
          title: 'Success',
          text: 'Template berhasil diunduh',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } catch (error) {
        console.error('Error downloading contractor training mapping template:', error);
        this.$swal({
          title: 'Error',
          text: 'Template belum berhasil diunduh. Silakan coba lagi.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.isDownloading = false;
      }
    },

    async uploadFile() {
      if (!this.selectedFile) {
        this.$swal({
          title: 'Error',
          text: 'Pilih file yang akan diunggah',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        return;
      }

      this.isUploading = true;
      
      try {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        
        const response = await this.$store.dispatch('courseMappingMitraFilters/uploadBulkMapping', formData);
        
        // Show detailed success message
        const data = response.data || {};
        const summary = data.summary || {};
        const processingErrors = data.processingErrors || [];
        
        let successMessage = `
          <div class="text-left">
            <p><strong>Bulk Unggah Berhasil!</strong></p>
            <ul class="list-unstyled mb-0">
              <li>✓ Rows Processed: ${summary.rowsProcessed || 0}</li>
              <li>✓ Groups Processed: ${summary.groupsProcessed || 0}</li>
              <li>✓ Mappings Created: ${summary.mappingsCreated || 0}</li>
            </ul>
          </div>
        `;
        
        // Show warnings if any
        if (summary.validationErrors > 0 || summary.processingErrors > 0) {
          successMessage += `
            <div class="mt-2 text-warning">
              <small>
                ⚠ Validasi Gagals: ${summary.validationErrors || 0}<br>
                ⚠ Processing Errors: ${summary.processingErrors || 0}
              </small>
            </div>
          `;
          
          // Show first few processing errors
          if (processingErrors.length > 0) {
            successMessage += `<div class="mt-2 text-left"><small><strong>Errors:</strong></small><ul class="small mb-0">`;
            processingErrors.slice(0, 3).forEach(err => {
              successMessage += `<li>${err.position || 'Unknown'}: ${err.error || 'Unknown error'}</li>`;
            });
            if (processingErrors.length > 3) {
              successMessage += `<li>... and ${processingErrors.length - 3} more errors</li>`;
            }
            successMessage += `</ul></div>`;
          }
        }
        
        await this.$swal({
          title: summary.processingErrors > 0 ? 'Partially Successful' : 'Berhasil',
          html: successMessage,
          icon: summary.processingErrors > 0 ? 'warning' : 'success',
          confirmButtonText: 'OK'
        });
        
        // Close modal and refresh data
        this.$bvModal.hide('modal-upload-mitra');
        this.selectedFile = null;
        
        // Reload trainings if filters are applied
        if (this.showTrainingTable && this.filters.position_id) {
          await this.loadTrainings();
          this.loadTrainingMapping();
        }
        
      } catch (error) {
        console.error('Upload error:', error);
        
        let errorMessage = 'File belum berhasil diunggah. Silakan coba lagi.';
        
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          
          // Check for validation or processing errors
          if (errorData.data && (errorData.data.validationErrors || errorData.data.processingErrors)) {
            const validationErrors = errorData.data.validationErrors || [];
            const processingErrors = errorData.data.processingErrors || [];
            
            let errorDetails = '<div class="text-left"><ul class="mb-0">';
            
            validationErrors.forEach(err => {
              errorDetails += `<li>${err.message || err}</li>`;
            });
            
            processingErrors.forEach(err => {
              errorDetails += `<li>${err.position || 'Unknown'}: ${err.error || err.message || err}</li>`;
            });
            
            errorDetails += '</ul></div>';
            
            this.$swal({
              title: 'Unggah Gagal',
              html: errorDetails,
              icon: 'error',
              confirmButtonText: 'OK'
            });
            return;
          }
          
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          }
        }
        
        this.$swal({
          title: 'Error',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.isUploading = false;
      }
    }
  }
};
